import { parseSubscriberStatus, SubscriberStatus } from '../enums/subscriber-status'
import { StorageType } from '@core/storage/abstract-data-store.ts'
import { AbstractStorageManager } from './abstract-storage-manager'
import { Logger, TaggedLogger } from '@core/logging/logger'
import { LegacyStorageKey, UserStorageKey } from '@core/storage/keys.ts'

/** @internal */
export class LegacyStorageManager extends AbstractStorageManager {
    public constructor(logger?: Logger) {
        super(
            null,
            [
                // Legacy (pushly-sdk-v2) used cookie only storage
                StorageType.LEGACY_COOKIE,
            ],
            logger ?? TaggedLogger._getInstance('LegacyStoreManager'),
        )
    }

    public _getAnonymousId(): string | null {
        return this._getDataSync<string>(LegacyStorageKey[UserStorageKey.anonymousId]).unwrapOrNull()
    }

    public _getExternalId(): string | null {
        return this._getDataSync<string>(LegacyStorageKey[UserStorageKey.externalId]).unwrapOrNull()
    }

    public _getSubscriberStatus(): SubscriberStatus | null {
        let state: SubscriberStatus | null = null

        const raw = this._getDataSync<string>(LegacyStorageKey[UserStorageKey.subscriberStatus]).unwrapOrNull()
        if (raw) {
            state = parseSubscriberStatus(raw)
        }

        return state
    }

    public _getIsInDeletedState(): boolean | null {
        return this._getDataSync<boolean>(LegacyStorageKey[UserStorageKey.isInDeletedState]).unwrapOrNull()
    }

    public async _getDismissedStatusExpiration(): Promise<number | null> {
        const req = await this._getData<number>(LegacyStorageKey[UserStorageKey.DISMISSED_STATUS_EXPIRATION])
        return req.unwrapOrNull()
    }
}
